import { useCallback, useEffect, useState } from 'react';
import { getFreeCourses } from '../services/courses';
import { mapCourse } from '../utils/dashboardMappers';

export function useFreeCourses() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCourses = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await getFreeCourses();
      const list = (res?.data?.courses || []).map(mapCourse);
      setCourses(list);
    } catch (e) {
      setError(e?.message || 'Failed to load free courses');
      setCourses([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCourses();
  }, [fetchCourses]);

  return { courses, loading, error, refetch: fetchCourses };
}
